import React from "react";
import doc1 from '../assets/uploads/2015/07/doc1.jpg'
import doc2 from '../assets/uploads/2015/07/doctor-150x150.jpg'

const team = [
  {
    name: "Dr. Sanjay Chaurasiya",
    role: "Lead Yoga Instructor",
    image:doc1,
    desc: "15+ years of experience in Hatha and Vinyasa yoga."
  },
  {
    name: "Ruchi Chaurasiya",
    role: "Detox Specialist",
    image:doc2,
    desc: "Specialist in holistic detox therapies."
  }
];

function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-6 text-green-800">About DivineWellness</h1>
      <p className="mb-4 text-lg">DivineWellness is dedicated to holistic health and well-being through yoga, naturopathy, and detox therapies. Our mission is to empower individuals to achieve balance in mind, body, and spirit.</p>
      <ul className="mb-6 list-disc list-inside text-green-700">
        <li>Mission: To promote holistic wellness and natural healing.</li>
        <li>Values: Compassion, Integrity, Excellence, Community.</li>
        <li>History: Serving the community since 2010 with a team of certified experts.</li>
      </ul>
      <h2 className="text-2xl font-bold mb-4">Meet Our Team</h2>
      <div className="flex flex-wrap gap-8 justify-center">
        {team.map(member => (
          <div key={member.name} className="bg-white rounded-lg shadow p-6 w-64 flex flex-col items-center">
            <img src={member.image} alt={member.name} className="w-24 h-24 rounded-full mb-3 object-cover" />
            <h3 className="text-lg font-semibold">{member.name}</h3>
            <p className="text-green-700 mb-1">{member.role}</p>
            <p className="text-gray-600 text-center text-sm">{member.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default About;
